enum SessionStorageKeyEnum {
  JWTTokens = 'jwtTokens',
  MasterPasswordHash = 's',
  Guid = 'guid',
}

export default SessionStorageKeyEnum;
